import { BrandsRow } from "@/components/BrandsRow";
import { WarrantyBlock } from "@/components/WarrantyBlock";
import { HomeServiceAreas } from "@/components/HomeServiceAreas";
import { Testimonials } from "@/components/Testimonials";
import { HomeHero, TrustStrip, FeaturedOffers, MaintenanceBanner, EstimateSection, FaqLeadSection, FinalCta } from "@/components/home/HomeSections";
import { Seo } from "@/components/Seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo title="AC Repair & Maintenance in South Florida | Central Air Depot" description="South Florida AC repair, maintenance & installs since 1998. Duct cleaning $67/vent, $99 diagnostic waived with repair, plans from $24.99/mo." />
      <HomeHero />
      <TrustStrip />
      <FeaturedOffers />
      <BrandsRow />
      <MaintenanceBanner />
      <EstimateSection />
      <WarrantyBlock />
      <HomeServiceAreas />
      <Testimonials />
      <FaqLeadSection />
      <FinalCta />
    </div>
  );
}
